import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { useAuth } from '@/hooks/useAuth';
import { toast } from 'sonner';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');

    (async () => {
      if (!sessionId) { navigate('/login'); return; }
      try {
        await api.post('/auth/google/session', {}, {
          headers: { 'X-Session-ID': sessionId },
          withCredentials: true,
        });
        await refresh();
        toast.success('Signed in with Google');
        // Clear hash and go to dashboard
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard');
      } catch (e) {
        toast.error('Google sign-in failed');
        navigate('/login');
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#0B0E11] text-[#848E9C]">
      <div className="text-sm">Completing sign-in...</div>
    </div>
  );
}
